// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"c91b7041","671":"945fb3c8"}[chunkId] + ".chunk.css";
};